export default {"src":"/_next/static/media/BPMS_Feautre_Filters.e5a3df22.gif","height":1080,"width":1080};